function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.3742 42.6022L9.73333 42.5111C8.22089 42.5111 7 41.272 7 39.7778V6.97778C7 5.46533 8.22089 4.24445 9.73333 4.24445H33.4222C34.9164 4.24445 36.1556 5.46533 36.1556 6.97778V31.6142",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.313 35.2222H10.6445V7.88889H32.5112V28.7351",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48 46.1556L42.5333 38.8667V30.5573C42.5333 27.4778 39.6542 24.544 36.1555 21.5556",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.978 33.4L33.878 29.3C33.1309 28.5529 31.8918 28.5529 31.1447 29.3C30.3976 30.0471 30.6891 31.5778 31.1447 32.0333L35.2447 37.9556C35.2447 37.9556 35.2447 37.9556 35.2447 39.7778C35.2447 41.6 38.8891 46.1556 38.8891 46.1556",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.0769 38.8667H24.2565",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.3777 38.8667C14.3777 38.8798 14.3704 38.9055 14.349 38.9269C14.3276 38.9483 14.3019 38.9556 14.2888 38.9556C14.2757 38.9556 14.25 38.9483 14.2286 38.9269C14.2072 38.9055 14.1999 38.8798 14.1999 38.8667C14.1999 38.8535 14.2072 38.8278 14.2286 38.8064C14.25 38.7851 14.2757 38.7778 14.2888 38.7778C14.3019 38.7778 14.3276 38.7851 14.349 38.8064C14.3704 38.8278 14.3777 38.8535 14.3777 38.8667Z",
  fill: "#ACB5BF",
  stroke: "#ACB5BF",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.1333 38.8667C27.1333 38.8798 27.126 38.9055 27.1046 38.9269C27.0832 38.9483 27.0575 38.9556 27.0444 38.9556C27.0313 38.9556 27.0056 38.9483 26.9842 38.9269C26.9628 38.9055 26.9555 38.8798 26.9555 38.8667C26.9555 38.8535 26.9628 38.8278 26.9842 38.8064C27.0056 38.7851 27.0313 38.7778 27.0444 38.7778C27.0575 38.7778 27.0832 38.7851 27.1046 38.8064C27.126 38.8278 27.1333 38.8535 27.1333 38.8667Z",
  fill: "#ACB5BF",
  stroke: "#ACB5BF",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2 27.9333H27.9555",
  stroke: "#FFD200",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2 24.2889H27.9555",
  stroke: "#FFD200",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2 20.6444H27.9555",
  stroke: "#FFD200",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2 17H27.9555",
  stroke: "#FFD200",
  strokeWidth: 2,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2 13.3556H22.4888",
  stroke: "#FFD200",
  strokeWidth: 2,
  strokeMiterlimit: 10
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48.0005,
  height: 48.0002,
  fill: "white"
})));

function SvgGadget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGadget);
export default __webpack_public_path__ + "static/media/gadget.e93c0cbd.svg";
export { ForwardRef as ReactComponent };